export default "__VITE_ASSET__DtO6CUbB__"